module.exports = __webpack_public_path__ + "img/music-note-terrarium.f646333d.jpg";